var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeAutoObservable, runInAction } from 'mobx';
import { surveysService } from 'ziphy-web-shared/basic/api';
class BookingLiveqServicesStore {
    constructor() {
        this.survey = null;
        this.branches = [];
        this.content = [];
        this.token = null;
        makeAutoObservable(this);
    }
    get resultType() {
        if (this.survey.status !== 'completed' && this.survey.status !== 'submitted') {
            return false;
        }
        const forbidden = this.survey.answers.some((answer) => {
            return answer.values.some((value) => {
                const slot_id = value.slot_id;
                if (this.branches.find(el => el.id === slot_id && el.tags.includes('consultation_forbidden'))) {
                    return true;
                }
            });
        });
        if (forbidden) {
            return 'warning';
        }
        return 'success';
    }
    get currentStepId() {
        return this.survey.next_step_id;
    }
    get currentStep() {
        return this.branches.filter(branch => branch.parents.some((el) => el.id === this.survey.next_step_id));
    }
    get currentQuestons() {
        return this.branches.filter(branch => {
            if (branch.variation !== 'question') {
                return false;
            }
            const parent = branch.parents.at(-1);
            return parent.id === this.survey.next_step_id;
        }).sort((a, b) => a.order - b.order);
    }
    get currentButtons() {
        return this.branches.filter(branch => {
            if (branch.variation !== 'button') {
                return false;
            }
            const parent = branch.parents.at(-1);
            return parent.id === this.survey.next_step_id;
        }).sort((a, b) => a.order - b.order);
    }
    start(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { survey, token } = yield surveysService.startSurvey(params);
            runInAction(() => {
                this.survey = survey;
                this.token = token;
            });
        });
    }
    load(survey_id, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { survey, branches, content } = yield surveysService.loadSurvey(survey_id, token);
            runInAction(() => {
                this.survey = survey;
                this.branches = branches;
                this.content = content;
                this.token = token || null;
            });
        });
    }
    answer(button_id, answers, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { survey } = yield surveysService.sendAnswers(this.survey._id, { step_id: this.currentStepId, button_id, values: answers }, token);
            this.survey = survey;
        });
    }
    back(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { survey } = yield surveysService.rollback(this.survey._id, this.currentStepId, token);
            this.survey = survey;
        });
    }
    submit(patientId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { survey } = yield surveysService.submit(this.survey._id, patientId, this.token);
            this.survey = survey;
        });
    }
}
const store = new BookingLiveqServicesStore();
export default store;
